export default class WebsocketService {
    socket: WebSocket
    constructor() {
        this.socket = new WebSocket('wss://fin-rassvet.su/ws')
        this.socket.addEventListener('open', e => {
            console.log('opened websocket')
            const token = localStorage.getItem('accessToken')
            if(token) {
            const data = JSON.stringify({
                type: 'connect_user',
                accessToken: token
            })
            this.sendMessage(data)
        }
        })
        this.socket.addEventListener('error', e => {
            console.log(e)
        })
        this.socket.addEventListener('close', e => {
            console.log('closed')
            this.socket = new WebSocket('wss://fin-rassvet.su/ws')
        })
    }
    sendMessage(message: string | ArrayBufferLike | Blob | ArrayBufferView) {
       if(this.socket.readyState === 1) {
        this.socket.send(message)
    }
    }
}